import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutAboutHeliumAutomotiveContentSectionHeaderCls: string;
			aboutAboutHeliumAutomotiveContentSectionTextInnerCls: string;
		}
	},

	slug: string
}

class Automotive extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About About Helium Automotive Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumAutomotiveContentSectionHeaderCls || '','about_about_helium_automotive', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumAutomotiveContentSectionTextInnerCls || '','about_about_helium_automotive', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Automotive;